import { ESCAPE, ENTER, MAC_ENTER } from '@angular/cdk/keycodes';
import { OverlayRef } from '@angular/cdk/overlay';
import { Subject, Subscription } from 'rxjs';
import { ModalService } from '@nimbus-library/features/modal/services/modal.service';
import { ModalConfiguration } from './modal-configuration.model';

export class Modal<TParameters = {}> {
  private readonly subscription$: Subscription;

  public child: Modal;

  public submit: Subject<void> = new Subject<void>();
  public afterClose: Subject<any> = new Subject<any>();
  public beforeClose: Subject<any> = new Subject<any>();

  public constructor(
    public readonly overlayRef: OverlayRef,
    private readonly modalService: ModalService,
    public readonly configuration: ModalConfiguration,
    public readonly parameters: TParameters,
  ) {
    this.subscription$ = new Subscription();

    this.subscription$.add(
      this.overlayRef.keydownEvents().subscribe((event: KeyboardEvent) => {
        const keyCode = event.keyCode;

        if (keyCode === ESCAPE) {
          this.close();
        }
        if (keyCode === ENTER || keyCode === MAC_ENTER) {
          this.submit.next();
        }
      }),
    );

    this.subscription$.add(
      this.overlayRef.backdropClick().subscribe((event: MouseEvent) => {
        this.close();
      }),
    );
  }

  public close(force: boolean = false, data?: any): void {
    if (force || (this.configuration.closable && (this.configuration.closeCallback === undefined || this.configuration.closeCallback()))) {
      this.beforeClose.next(data);
      this.modalService.close(this);
      this.afterClose.next(data);

      this.finalize();
    }
  }

  public finalize(): void {
    this.subscription$.unsubscribe();
    this.submit.complete();
    this.afterClose.complete();
    this.beforeClose.complete();
  }
}
